import { render, staticRenderFns } from "./ModalAddAudio.vue?vue&type=template&id=e3d97674&scoped=true&"
import script from "./ModalAddAudio.vue?vue&type=script&lang=js&"
export * from "./ModalAddAudio.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAudio.vue?vue&type=style&index=0&id=e3d97674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d97674",
  null
  
)

export default component.exports